import { render, staticRenderFns } from "./contest-info-page.html?vue&type=template&id=240eefa2&scoped=true&"
import script from "./contest-info-page.js?vue&type=script&lang=js&"
export * from "./contest-info-page.js?vue&type=script&lang=js&"
import style0 from "./contest-info-page.scss?vue&type=style&index=0&id=240eefa2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240eefa2",
  null
  
)

export default component.exports